import * as React from 'react';
export const unifederalSvg = React.forwardRef(function unifederalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FC913F',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M16 22.49h3.14s-8.78-3.42-9.41-6.15c-.63-2.73 0-2.73 0-2.73s3.76 4.78 9.4 4.78c5.65 0 6.9-.68 8.16-.68 1.25 0 1.25-1.24 1.25-1.71 0-3.58-5.61-6.49-12.54-6.49-6.93 0-12.54 2.9-12.54 6.49 0 3.58 5.61 6.49 12.54 6.49z',
      }),
    ),
  );
});
unifederalSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var unifederal = {
  category: 'brand',
  colorable: false,
  name: 'unifederal',
  svg: unifederalSvg,
};
